var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 5.0454V7.69694M7 10.3485H7.00574M6.018 1.63819L1.15392 11.0114C1.05363 11.2118 1.00057 11.4391 1 11.6706C0.999443 11.9021 1.0514 12.1297 1.15071 12.3308C1.25003 12.532 1.39323 12.6995 1.56607 12.8169C1.73892 12.9343 1.93538 12.9975 2.13592 13H11.8641C12.0646 12.9975 12.2611 12.9343 12.4339 12.8169C12.6068 12.6995 12.75 12.532 12.8493 12.3308C12.9486 12.1297 13.0006 11.9021 13 11.6706C12.9994 11.4391 12.9464 11.2118 12.8461 11.0114L7.982 1.63819C7.87963 1.44337 7.73548 1.2823 7.56347 1.17051C7.39146 1.05873 7.1974 1 7 1C6.8026 1 6.60854 1.05873 6.43653 1.17051C6.26452 1.2823 6.12037 1.44337 6.018 1.63819Z","stroke":"currentColor","strokeWidth":"1.3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Alert.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Alert;

Alert.default = Alert;
